import { useSelector } from 'react-redux';

export const getStudent = () => {
  const { student } = useSelector((state) => state.schoolResults);
  return student;
};
